import type { TDuration } from './common.type';

export const CNsPrice = 'price';
export const CNsDuration = 'duration';
export const CNsDiscount = 'discount';
export const CNsTrial = 'trialPeriod';

export enum ECurrency {
  USD = 'USD',
  EUR = 'EUR',
}

export enum EDiscountType {
  PERCENT = 'Percent',
  FIXED = 'Fixed',
}

export const CDiscountTypeValues = {
  PERCENT: '%',
  FIXED: ECurrency,
} as const;

export type TDiscountType = keyof typeof EDiscountType;

type TDiscountValue = number;
export type TDiscount = {
  type: TDiscountType;
  value: TDiscountValue;
};

export interface IPrice {
  isDiscounted: boolean;
  currency: keyof typeof ECurrency;
  originalPrice: number;
  [CNsDuration]: TDuration;
  [CNsDiscount]: TDiscount | null;
}

export const DEFAULT_PRICE: IPrice = {
  isDiscounted: false,
  currency: ECurrency.USD,
  originalPrice: 1,
  [CNsDuration]: {
    period: 1,
    type: 'MONTH',
  },
  [CNsDiscount]: {
    type: 'PERCENT',
    value: 1,
  },
};

export const DEFAULT_PRICE_VALUES = (
  currency: keyof typeof ECurrency = DEFAULT_PRICE.currency,
  isDiscounted: IPrice['isDiscounted'] = DEFAULT_PRICE.isDiscounted,
  overwrite = {},
) => ({
  [CNsPrice]: {
    currency,
    isDiscounted,
    originalPrice: DEFAULT_PRICE.originalPrice,
    [CNsDuration]: DEFAULT_PRICE[CNsDuration],
    [CNsDiscount]: DEFAULT_PRICE[CNsDiscount],
    ...overwrite,
  } as IPrice,
});
